import React from "react";
import { Link } from "react-router-dom";

const LinkColumn = ({ row = {}, name, extra }) => {
  const { formId } = row;
  return (
    <Link
      to={`${extra.url ? extra.url : "/v/s"}?formId=${formId}&formDataId=${
        row._id
      }&reset=1`}
    >
      Se detaljer
    </Link>
  );
};

export default LinkColumn;
